// import * as app from "./route/app";
import {getClient} from "../../config";

export async function init() {
  return await getClient().get({
    path: "/web/app/init",
  });
}
